import { movies } from "@/mocks/movies";
import type { Movie, MovieType } from "@/types/movie";

export function getMovieById(id: string): Movie | undefined {
  return movies.find((m) => m.id === id);
}

export interface FilterOptions {
  type?: MovieType;
  tags?: string[];
  yearFrom?: number | null;
  yearTo?: number | null;
  theme?: string;
  sort?: "hot" | "rating" | "new" | "old";
}

export function filterMovies(options: FilterOptions): Movie[] {
  let result = movies.slice();

  if (options.type) {
    result = result.filter((m) => m.type === options.type);
  }
  if (options.theme) {
    result = result.filter((m) => m.theme === options.theme);
  }
  if (options.tags && options.tags.length > 0) {
    result = result.filter((m) => options.tags!.every((tag) => m.tags.includes(tag)));
  }
  if (options.yearFrom) {
    result = result.filter((m) => m.year >= options.yearFrom!);
  }
  if (options.yearTo) {
    result = result.filter((m) => m.year <= options.yearTo!);
  }

  switch (options.sort) {
    case "rating":
      result.sort((a, b) => b.rating - a.rating);
      break;
    case "new":
      result.sort((a, b) => b.year - a.year);
      break;
    case "old":
      result.sort((a, b) => a.year - b.year);
      break;
    default:
      result.sort((a, b) => b.popularity - a.popularity);
  }

  return result;
}

export function searchMovies(keyword: string, type?: MovieType | "all"): Movie[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return movies.filter((m) => {
    const matchesKw =
      m.title.toLowerCase().includes(kw) ||
      m.director.toLowerCase().includes(kw) ||
      m.cast.some((c) => c.toLowerCase().includes(kw)) ||
      m.tags.some((t) => t.toLowerCase().includes(kw));
    const matchesType = !type || type === "all" || m.type === type;
    return matchesKw && matchesType;
  });
}

export function getRelated(movie: Movie, limit = 6): Movie[] {
  return movies
    .filter((m) => m.id !== movie.id)
    .map((m) => {
      const tagScore = m.tags.filter((t) => movie.tags.includes(t)).length;
      const themeScore = m.theme === movie.theme ? 2 : 0;
      const typeScore = m.type === movie.type ? 1 : 0;
      return { m, score: tagScore * 2 + themeScore + typeScore };
    })
    .sort((a, b) => b.score - a.score || b.m.popularity - a.m.popularity)
    .slice(0, limit)
    .map((item) => item.m);
}

export function getHotMovies(limit = 6): Movie[] {
  return movies.slice().sort((a, b) => b.popularity - a.popularity).slice(0, limit);
}

export const yearOptions = [2024, 2023, 2022, 2021];